export const DEFAULT_ROLE_PROFILE_ICON_SIZE = 22;
